import { Button } from "@/components/ui/button";
import PageLoader from "./PageLoader";

/**
 * Shows a loading or error state for a resource, or nothing when it is ready.
 * size="compact" small loader for sections, forms and lists (default)
 * size="page"    optional centered loader within a page's content area
 */
export default function ResourceStatus({ loading, error, onRetry, label = "Loading…", hint, size = "compact" }) {
  if (error) return (
    <div role="alert" className="flex items-start gap-3 rounded-xl border border-destructive/30 bg-destructive/5 p-4 text-sm">
      <svg aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-destructive" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" /><path d="M12 7.5v5.5M12 16.5h.01" />
      </svg>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-destructive">Something went wrong</p>
        <p className="mt-0.5 break-words text-muted-foreground">{String(error)}</p>
      </div>
      {onRetry && <Button type="button" variant="outline" size="sm" onClick={onRetry}>Try again</Button>}
    </div>
  );
  if (loading) return <PageLoader label={label} hint={hint} className={size === "compact" ? "pl-compact" : ""} />;
  return null;
}
